// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c3bb557f","238":"71476d4a","239":"2f822dd7","455":"a839625a","866":"b0f19678","977":"c7d6623c"}[chunkId] + ".chunk.js";
};